import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IConsultAnonymousCardFormMeta {
  idBank: FormInputMeta,
  nameBank: FormInputMeta,
  agency: FormInputMeta,
  targetAudience: FormInputMeta,  
  cardCategory: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  // Schema
  schema: any,
}

const ConsultAnonymousCardFormMeta = {} as IConsultAnonymousCardFormMeta;

ConsultAnonymousCardFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID Banque',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Raison sociale',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultAnonymousCardFormMeta.agency = {
  label: 'Agence',
  name: 'agency',
  type: 'select',
  placeholder: 'Select ...',
  options:  [
    {
      label: 'Agence 1',
      value: '1'
    },
    {
      label: 'Agence 2',
      value: '2',
    },
    {
      label: 'Agence 3',
      value: '3',
    },
  ],   
  validation: yup.string().required(),
}
ConsultAnonymousCardFormMeta.targetAudience = {
  label: 'Audience cible',
  name: 'targetAudience',
  type: 'select',
  placeholder: 'Select ...',
  options:  [
    {
      label: 'Audience 1',
      value: '1'
    },
    {
      label: 'Audience 2',
      value: '2',
    },
    {
      label: 'Audience 3',
      value: '3',
    },
  ],   
  validation: yup.string().required(),
}
ConsultAnonymousCardFormMeta.cardCategory = {
  label: 'Categorie carte',
  name: 'cardCategory',
  type: 'select',
  placeholder: 'Select ...',
  options:  [
    {
      label: 'Categorie 1',
      value: '1'
    },
    {
      label: 'Categorie 2',
      value: '2',
    },
    {
      label: 'Categorie 3',
      value: '3',
    },
  ],   
  validation: yup.string().required(),
}

ConsultAnonymousCardFormMeta.startDate = {
  name: 'startDate',
  type: 'date',
  label: 'Date creation du',
  placeholder: '',
  validation: yup.string().required(),
};

ConsultAnonymousCardFormMeta.endDate = {
  name: 'endDate',
  type: 'date',
  label: 'Au',
  placeholder: '',
  validation: yup.string().required(),
};

ConsultAnonymousCardFormMeta.schema = yup.object().shape(getValidationSchema(ConsultAnonymousCardFormMeta));

export default ConsultAnonymousCardFormMeta;